import { buildOnServeLiveMobileProps } from "../buildOnServeLiveMobileProps";
import { getBackgroundImage } from "../../helpers";
export const buildOnServeLiveDesktopProps = (event, config) => {
    return Object.assign(Object.assign({}, buildOnServeLiveMobileProps(event, config)), { backgroundImage: getBackgroundImage(event, config.cmsConfig.backgroundImages) });
};
//# sourceMappingURL=buildOnServeLiveDesktopProps.js.map